import {
    Grid,
    IconButton,
    Tooltip,
} from "@mui/material";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { useTheme } from "@mui/material/styles";

const SiderBarMenu = ({ isMenuOpen, setIsMenuOpen }) => {
    const theme = useTheme();

    return (
        <Grid
            sx={{
                margin: '5px',
                display: isMenuOpen ? 'none' : 'inline-block',
            }}
        >
            <Tooltip title="Open Sidebar">
                <IconButton
                    sx={{
                        padding: '10px',
                        color: theme.palette.primary[500],
                        backgroundColor: theme.palette.primary[100],
                    }}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <MenuOpenIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Grid>
    );
}

export default SiderBarMenu;